import React from 'react';
import type { CheckboxProps } from './Checkbox.props';
import IcCheckBoxSelected from './assets/IcCheckboxSelected.svg';
import IcCheckBox from './assets/IcCheckBox.svg';
import IcCheckBoxCircle from './assets/IcCheckBoxCircle.svg';
import IcCheckBoxCircleSelected from './assets/IcCheckBoxCircleSelected.svg';
import { Text } from '../Text';

import styled from 'styled-components';

const Checkbox = ({ value, onChange, label, size = 24, disabled, style, className, circle }: CheckboxProps) => {

  const handleToggle = () => {
    if (!disabled) {
      onChange?.(!value);
    }
  };

  const uncheckedSrc = circle ? IcCheckBoxCircle : IcCheckBox;
  const checkedSrc = circle ? IcCheckBoxCircleSelected : IcCheckBoxSelected;

  return (
    <Container onClick={handleToggle} style={style} className={className} type='button'>
      <WrapperIcon disabled={disabled}>
        {value ? <img src={checkedSrc} width={size} height={size} alt='checked' /> : <img src={uncheckedSrc} width={size} height={size} alt='unchecked' />}
      </WrapperIcon>

      {label && (
        <Text content_2 medium className='styled-text' color={disabled ? 'neutral.text.4' : 'neutral.text.6'}>
          {label}
        </Text>
      )}
    </Container>
  );
};

export default Checkbox;

const WrapperIcon = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  ${({ disabled }) => disabled && `
    cursor: not-allowed;
    opacity: 0.6;
  `}
`;

const Container = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
`;
